import { render, staticRenderFns } from "./HorizontalNavMenuHeader.vue?vue&type=template&id=1c772f45"
import script from "./HorizontalNavMenuHeader.vue?vue&type=script&lang=js"
export * from "./HorizontalNavMenuHeader.vue?vue&type=script&lang=js"
import style0 from "./HorizontalNavMenuHeader.vue?vue&type=style&index=0&id=1c772f45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports